<template>
    <div>
        <TurnaroundTimeLine v-if="turnaroundTime" class="mb-5">
            Ships within {{ turnaroundTime }}
        </TurnaroundTimeLine>

        <div class="flex flex-col gap-4">
            <button class="btn-primary text-center" @click="onGoToQuote">
                Build your {{ familyProductTypeShortLabel }} quote
            </button>

            <NuxtLink to="/sample-pack" class="btn-secondary text-center">
                Get your sample pack now
            </NuxtLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ProductData } from '~/types/product';
import { scrollToId } from '~/utils/helpers';

const emit = defineEmits(['showErrors']);

const props = defineProps<{
    productDatas: ProductData[];
    productId: number | null;
    contents: string | null;
    shape: string | null;
    turnaroundTime: string | null;
    showErrors: boolean;
    validationMessages: string[];
}>();

const { familyProductTypeShortLabel } = useFamilyProductDataLabels(
    computed(() => props.productDatas),
);

const onGoToQuote = async () => {
    if (props.validationMessages.length) {
        emit('showErrors', true);

        await nextTick();
        scrollToId('configurator-error');

        return;
    }

    let quoteUrl = '/get-quote';
    if (props.productId) {
        quoteUrl += `#product=${props.productId}`;

        if (props.contents) {
            quoteUrl += `&contents=${props.contents}`;
        }

        if (props.shape) {
            quoteUrl += `&shape=${props.shape}`;
        }
    }

    navigateTo(quoteUrl);
};
</script>
